export default __webpack_public_path__ + "static/media/rain.c7063ea7.png";